import { formApi } from "api/TenantSlug/Form/api.ts";

export function composeGetFormQueryOptions(formId: string, request?: unknown) {
    return {
        queryKey: ["getForm", formId, request],
        queryFn: () => formApi.show(formId, request),
    };
}

export function getFormQueryOptions(formId: string, request?: unknown) {
    return {
        ...composeGetFormQueryOptions(formId, request),
        suspense: true,
    };
}
